var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#new-success_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 7.5,
  fill: "#2B6638"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.638 5.946c.251.19.306.555.121.815l-4.496 6.334a.553.553 0 0 1-.82.1l-2.41-2.098a.596.596 0 0 1-.067-.822.553.553 0 0 1 .797-.07l1.946 1.697 4.139-5.83a.554.554 0 0 1 .79-.126",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-success_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgNewSuccess;